<template >
  <div style="display: flex; flex-wrap: wrap;" :style="noCoincideHistorico()?'background-color: #f8d7da; border-color: #f5c6cb; color: #721c24;':''">

    <f7-list-input v-if="!chipsView" style="flex: 1;"
      :value="getValue()"
      :type="type"
      autocomplete="off"
      @input="updateIfEmpty"
      v-bind="{...$attrs,...$props}"
      v-on="$listeners"
      :error-message-force="!!form.errors[name]"
      :error-message="form.errors[name]"
      :readonly="overrideReadonly ? readonly : readonly || form.readonly"
      :class="{readonly:overrideReadonly ? readonly : readonly || form.readonly}"
      v-tooltip="viewTooltip ? (label ? label + ':<br>' : '') + (getValue() ? getValue() : '') : ''"
    >
      <slot name="inner-end" slot="inner-end">
      </slot>
      <slot name="inner-start" slot="root-end"></slot>
    </f7-list-input>

    <div
      v-else
      class="r-m2m-chips-field"
      :class="{readonly: overrideReadonly ? readonly : readonly || form.readonly, 'has-error': !!form.errors[name]}"
      style="flex: 1;"
      @click="openChipsPicker"
    >
      <label v-if="label" class="r-m2m-chips-label">{{ label }}</label>
      <div class="r-m2m-chips-content">
        <div
          v-for="chip in chipsList"
          :key="chip.key"
          class="r-m2m-chip"
          :title="chip.text || chip.key"
        >
          <div class="r-m2m-chip-text">{{ chip.text || chip.key }}</div>
          <button
            v-if="!(overrideReadonly ? readonly : readonly || form.readonly)"
            type="button"
            class="r-m2m-chip-close"
            @click.stop="removeChipAt(chip.idx)"
            aria-label="Eliminar"
          >×</button>
        </div>
        <div v-if="!chipsList.length" class="r-m2m-chips-placeholder">{{ label || '' }}</div>
        <input
          ref="chipsHidden"
          type="text"
          class="r-m2m-chips-hidden-input"
          autocomplete="off"
          tabindex="-1"
        />
      </div>
      <div v-if="form.errors[name]" class="r-m2m-chips-error">{{ form.errors[name] }}</div>
    </div>
    <f7-link
      v-if="hasHistory && Utils.posterior2Dic2024(form.dateRef)"
      class="input-suffix-btn r-input-little r-input-top history-link"
      :class="{'color-historico-ultimo-online': hayCambiosOnline()}"
      style="top: 5px;right: 29px;"
      :icon-f7="'archivebox'"
      v-tooltip="'Historico de valores'"
      @click.stop="showHistory"
    ></f7-link>
    <span v-if="htmlError" v-tooltip="tooltipError" v-html="htmlError()" @click.stop="mostrarError()" style="z-index: 100;"></span>
    
    <f7-popover class="history-popover" :closeByBackdropClick="true" :backdrop="true" closeOnEscape ref="popoverHistory" style="width: auto; max-width: 90%;">
      <div style="min-width: 250px;">
        <f7-navbar :title="$t('Historico de cambios')">
          <f7-nav-right>
            <f7-link popover-close icon-f7="multiply"></f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block>
          <div class="scrollable-content">
            <table>
              <thead>
                <tr style="background-color: #22355b;color: #FFF;">
                  <th>Valor</th>
                  <th>Fecha</th>
                  <th>Usuario</th>
                </tr>
              </thead>
              <tbody  v-if="form.username != 'NOID'">
                <tr v-for="(itm, idx) in history" :key="'history-' + idx" :class="(idx%2?'fila-impar':'fila-par')">
                  <td class="datos-valor" :title="itm && itm.msgHistory?itm.msgHistory:''" v-html="getStrValueHistory(itm.valor) ||''"></td>
                  <td class="datos-auditoria">{{itm.date}}</td>
                  <td class="datos-auditoria">{{itm.username || ' - '}}</td>
                </tr>
              </tbody>
              <tbody  v-else>
                <tr v-for="(itm, idx) in history" :key="'history-' + idx" :class="(idx%2?'fila-impar':'fila-par')">
                  <td class="datos-valor" :title="itm && itm.msgHistory?itm.msgHistory:''" v-html="itm.valor || ''"></td>
                  <!-- <td class="datos-valor" :title="itm && itm.msgHistory?itm.msgHistory:''">
                    <div>
                      <f7-list-input
                        :value="getValueHistory(itm.valor)"
                        v-tooltip="getValueHistory(itm.valor)"
                        :type="type"
                        autocomplete="off"
                        @input="setValueHistory($event.target.value, $event.target, true, false, itm)"
                        @change="type == 'date' || type == 'datetime-local' ? null : setValueHistory($event.target.value, $event.target, true, false, itm)"
                        @input:clear="setValueHistory(null, null, false, false, itm)"
                        v-bind="{...$attrs,...$props}"
                        v-on="$listeners"
                        :label="undefined"
                      ></f7-list-input>
                    </div>
                  </td> -->
                  <td class="datos-auditoria">
                    <f7-list-input
                      :value="getDateHistory(itm.date)"
                      :type="'datetime-local'"
                      @input="itm.date = $event.target.value"
                      @change="itm.date = $event.target.value"
                      @calendar:change="itm.date = $event.target.value"
                      v-on="$listeners"
                    ></f7-list-input>
                  </td>
                  <td class="datos-auditoria">
                    <f7-list-input
                      :value="itm.username"
                      type="text"
                      @change="itm.username = $event.target.value"
                    />
                  </td>
                  <td class="datos-opciones">
                    <f7-link @click="updateHistory(itm)" icon-f7="floppy_disk"></f7-link>
                    <f7-link @click="deleteFieldFromHistory(itm)" icon-f7="trash" color="red"></f7-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </f7-block>
      </div>
    </f7-popover>
  </div>
</template>

<script>

import DateUtils from "./../js/DateUtils";
import Utils from "./../js/Utils";
import DatabaseModel from '../js/db/DatabaseModel'
import ConfigCombo from '../js/db/ConfigCombo';
import EntityUtils from "./../js/EntityUtils";
import JSONPath from 'jsonpath';

export default {
  
  props: {
    chipsView: {
      type: Boolean,
      default: false
    },
    lineBreak: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "text"
    },
    dbAdapter: {
      type: Object
    },
    name: {
      required: true,
      type: String
    },
    altername: {
      required: false,
      type: String,
      default: ''
    },
    nameId: {
      type: String
    },
    form: {
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    labelProp: {
      type: String,
      default: "name"
    },
    prefixProp: {
      type: String
    },
    idProp: {
      type: String,
      default: ""
    },
    valueProperty: {
      type: String,
      default: ""
    },
    minLength: {
      type: Number,
      default: 0
    },
    searchProp: {
      type: String,
      default: function() {
        return this.labelProp;
      }
    },
    filter: {
      type: Object,
      default: function() {
        return {};
      }
    },
    shownFields: {
      type: Array,
      default: function (){
        return [];
      }
    },
    source: {
      type: Function,
      default: function(self) {
        return function(query, render) {
          var results = [];
          if (query.length >= self.minLength) {
            for (var i = 0; i < self.items.length; i++) {
              const originalValue = self.items[i][self.searchProp];
              const translatedValue = self.isTranslationKey(originalValue) ? self.$t(originalValue) : originalValue;
              var txtValue = translatedValue;
              if (self.prefixProp && self.items[i][self.prefixProp]) {
                const prefixValue = self.items[i][self.prefixProp];
                const translatedPrefix = self.isTranslationKey(prefixValue) ? self.$t(prefixValue) : prefixValue;
                txtValue = translatedPrefix + ' - ' + translatedValue;
              }
              if (
                (!txtValue && (!query || query == "")) ||
                (txtValue && txtValue.toLowerCase().indexOf(query.toLowerCase()) >= 0)
              ) {
                self.items[i]['txtValue'] = txtValue;
                results.push(self.items[i]);
              }
            }
          }
          render(results);
        };
      }
    },
    onchange: {
      type: Function,
      default: function(self) {
        return function(value) {
          self.setValue(value);
          // self.$emit("change", value[0]);
          // self.form.$emit("change", self.name, value[0]);
        };
      }
    },
    onopened: {
      type: Function,
      default: function(self) {
        return function(value) {
          self.autocomplete.$el[0].getElementsByClassName("select-all-btn")[0].addEventListener("click", function(event) {self.onSelectAll(event)});
          self.autocomplete.$el[0].getElementsByClassName("deselect-all-btn")[0].addEventListener("click", function(event) {self.onDeSelectAll(event)});
        };
      }
    },
    autocompleteProps: {
      type: Object,
      default: function() {
        var $ = this.$$;
        var $el = $(this.$el);
        var self = this;
        return {};
      }
    },
    overrideReadonly: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    viewTooltip: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ""
    },
    dbItems: {
      type: Array,
      default: function() {
        return [];
      }
    },
    model: {
      type: String
    },
    configCombo: {
      // Código de un configcombo (tabla maestra) del que se cargarán los items
      // (configcombo.valores). Si se informa, se ignora dbAdapter/model.
      type: String,
      default: ""
    }
  },
  data() {
    return {
      _jqxhr: null,
      isLoading: false,
      items: [],
      autocomplete: null,
      DatabaseModel,
      dbAdapterData: null,
      history: [],
      DateUtils,
      EntityUtils,
      JSONPath,
      Utils
    };
  },
  computed: {
    hasHistory: function () {
      let self = this;
      let tiene = false;
      if(self.multiple) {
        // Si el campo es tipo array, el nombre de la propiedad será del estilo <nombreCampo>.<indice numérico>.<idCampo> y nos fijaremos en el idCampo == self.labelProp
        tiene = self.form.history && Object.keys(self.form.history).length > 0 && Object.keys(self.form.history).filter(k=> k.startsWith(self.name) && k.endsWith(self.labelProp)).length > 0;
      } else {
        tiene = self.form && self.form.history && self.form.history[self.name];
      }
      return tiene;
    },
    chipsList: function () {
      var self = this;
      var namespaces = self.name.split(".");
      var context = self.form.formData;
      for (var i = 0; i < namespaces.length; i++) {
        if (context == null) { break; }
        context = context[namespaces[i]];
      }
      if (!Array.isArray(context)) {
        return [];
      }
      return context.map(function (entry, idx) {
        var key = '';
        if (entry && typeof entry === 'object') {
          key = self.nameId ? entry[self.nameId] : (self.idProp && entry[self.idProp] !== undefined ? entry[self.idProp] : '');
        } else {
          key = entry;
        }
        var matched = null;
        if (key !== '' && self.idProp) {
          matched = (self.items || []).find(function (it) { return it[self.idProp] == key; });
        }
        var prefixSrc = matched ? matched : (entry && typeof entry === 'object' ? entry : null);
        var labelSrc = matched ? matched : (entry && typeof entry === 'object' ? entry : null);
        var prefix = prefixSrc && self.prefixProp ? prefixSrc[self.prefixProp] : '';
        var labelRaw = labelSrc ? labelSrc[self.labelProp] : (typeof entry === 'string' ? entry : '');
        if (!prefix && typeof entry === 'string') {
          prefix = entry;
        }
        var labelText = self.isTranslationKey(labelRaw) ? self.$t(labelRaw) : labelRaw;
        var prefixText = self.isTranslationKey(prefix) ? self.$t(prefix) : prefix;
        var text;
        if (prefixText && labelText && prefixText !== labelText) {
          text = prefixText + ' - ' + labelText;
        } else {
          text = prefixText || labelText || '';
        }
        return {
          key: (key !== '' && key !== undefined && key !== null) ? key : ('chip-' + idx),
          text: text,
          idx: idx
        };
      });
    },
    externalValue: function () {
      var self = this;
      var namespaces = self.name.split(".");
      var context = self.form ? self.form.formData : null;
      for (var i = 0; i < namespaces.length; i++) {
        if (context == null) { break; }
        context = context[namespaces[i]];
      }
      return context;
    },
  },
  watch: {
    externalValue: function (newVal) {
      var self = this;
      if (!self.autocomplete) { return; }
      var idProp = self.valueProperty || self.idProp || 'id';
      var formIds = Array.isArray(newVal)
        ? newVal.map(function (el) { return (el && typeof el === 'object') ? el[idProp] : el; })
        : [];
      var acIds = Array.isArray(self.autocomplete.value)
        ? self.autocomplete.value.map(function (el) { return (el && typeof el === 'object') ? el[idProp] : el; })
        : [];
      // Skip if already in sync
      if (formIds.length === acIds.length) {
        var sameOrder = true;
        for (var i = 0; i < formIds.length; i++) {
          if (formIds[i] !== acIds[i]) { sameOrder = false; break; }
        }
        if (sameOrder) { return; }
      }
      // Resync ac.value: try to match each id to a full object from self.items, fallback to synth
      var newAcValue = formIds.map(function (id) {
        if (self.idProp && Array.isArray(self.items)) {
          var found = self.items.find(function (it) { return it[self.idProp] == id; });
          if (found) { return found; }
        }
        var synth = {};
        if (self.idProp) { synth[self.idProp] = id; }
        if (self.labelProp) { synth[self.labelProp] = id; }
        return synth;
      });
      self.autocomplete.value = newAcValue;
      if (typeof self.autocomplete.updateValues === 'function') {
        try { self.autocomplete.updateValues(); } catch (e) { /* ignore */ }
      }
    }
  },
  methods: {
    removeChipAt: function (idx) {
      var self = this;
      var namespaces = self.name.split(".");
      var context = self.form.formData;
      for (var i = 0; i < namespaces.length - 1; i++) {
        if (context == null) { return; }
        context = context[namespaces[i]];
      }
      if (context == null) { return; }
      var arrKey = namespaces[namespaces.length - 1];
      var arr = context[arrKey];
      if (!Array.isArray(arr) || idx < 0 || idx >= arr.length) { return; }

      // Reconstruct array of full objects (setValue expects objects, not codes)
      var fullObjects = arr.map(function (entry) {
        if (entry && typeof entry === 'object') {
          return entry;
        }
        if (self.idProp && Array.isArray(self.items)) {
          var found = self.items.find(function (it) { return it[self.idProp] == entry; });
          if (found) { return found; }
        }
        var synth = {};
        if (self.idProp) { synth[self.idProp] = entry; }
        if (self.labelProp) { synth[self.labelProp] = entry; }
        return synth;
      });
      fullObjects.splice(idx, 1);

      // Keep F7 picker state in sync. F7 expects objects in ac.value when there's a valueProperty
      // (it pushes objects when user selects via the picker), so we mirror that shape here.
      if (self.autocomplete) {
        try {
          self.autocomplete.value = fullObjects.slice();
          if (typeof self.autocomplete.updateValues === 'function') {
            self.autocomplete.updateValues();
          }
        } catch (e) {
          // ignore
        }
      }

      self.setValue(fullObjects);
    },
    openChipsPicker: function () {
      var self = this;
      var isReadonly = self.overrideReadonly ? self.readonly : (self.readonly || self.form.readonly);
      if (isReadonly) {
        return;
      }
      if (self.autocomplete && typeof self.autocomplete.open === 'function') {
        self.autocomplete.open();
      }
    },
    isTranslationKey: function(value) {
      // Determina si un valor parece una clave de traducción
      // Las claves de traducción suelen tener puntos y no espacios
      return typeof value === 'string' &&
             value.includes('.') &&
             !value.includes(' ') &&
             value.length > 3;
    },
    mostrarError: function() {
      const self = this;
      var app = self.$f7;
      let expediente = self.form.formData;
      let htmlError = expediente.listErrorsForLabel.filter(e => e.valor == (self.altername || self.name))
                .flatMap(e => e.errores)
                .map(e => '<div class="regla regla-'+e.tipoRegla+'" ><span style="color: black;">'+e.nombre + '.- </span>' + e.error+'</div>').join(' ');
      let msg = '<div>' + htmlError + '</div>';
      app.dialog.alert(msg,'Errores del campo');
    },
    htmlError: function() {
      const self = this;
      let expediente = self.form.formData;
      let msgError;
      if(expediente.listErrorsForLabel && expediente.listErrorsForLabel.filter(e => e.valor == (self.altername || self.name)).length)
      {
        msgError = EntityUtils.formateoError(expediente, self.altername || self.name);
      }
      return msgError;
    },
    tooltipError: function() {
      const self = this;
      let expediente = self.form.formData;
      let msgError;
      if(expediente.listErrorsForLabel && expediente.listErrorsForLabel.filter(e => e.valor == (self.altername || self.name)).length)
      {
        msgError = EntityUtils.tooltipError(expediente, (self.altername ||self.name));
      }
      return msgError;
    },
    onSelectAll: function (e) {
      const self = this;
      const idProp = self.valueProperty || self.idProp || 'id';
      let labelItems = self.autocomplete.$el[0].firstElementChild.getElementsByClassName("item-checkbox");
      // creamos un array con todos los ids de los elementos visibles (filtrados por autocomplete self.autocomplete.items[*].id)
      let ids = self.autocomplete.items.map(el => el[idProp]);
      for (let index = 0; index < labelItems.length; index++) {
        const element = labelItems[index];
        var inputsCheckbox = element.getElementsByTagName("input");
        for (let i2 = 0; i2 < inputsCheckbox.length; i2++) {
          const checkElem = inputsCheckbox[i2];
          if (checkElem.type ==  "checkbox") {
            // Si checkElem.value está en ids, lo marcamos
            if (ids.includes(checkElem.value)) {
              checkElem.checked = true;
            }
          }
        }
      }
      // Sincronizamos también el estado interno de F7 (ac.value) para que futuras des/selecciones
      // desde el modal operen sobre el array correcto. Sin esto, F7 ve ac.value desactualizado y
      // al deseleccionar uno emite un cambio con el array obsoleto, vaciando formData.
      const existingIds = (self.autocomplete.value || [])
        .map(el => (el && typeof el === 'object') ? el[idProp] : el);
      const itemsToAdd = self.autocomplete.items.filter(it => !existingIds.includes(it[idProp]));
      self.autocomplete.value = [...(self.autocomplete.value || []), ...itemsToAdd];
      self.setValue(self.autocomplete.value);
    },
    onDeSelectAll: function (e) {
      const self = this;
      const idProp = self.valueProperty || self.idProp || 'id';
      var labelItems = self.autocomplete.$el[0].firstElementChild.getElementsByClassName("item-checkbox");
      // creamos un array con todos los ids de los elementos visibles (filtrados por autocomplete self.autocomplete.items[*].id)
      let ids = self.autocomplete.items.map(el => el[idProp]);
      for (let index = 0; index < labelItems.length; index++) {
        const element = labelItems[index];
        var inputsCheckbox = element.getElementsByTagName("input");
        for (let i2 = 0; i2 < inputsCheckbox.length; i2++) {
          const checkElem = inputsCheckbox[i2];
          if (checkElem.type ==  "checkbox") {
            // Si checkElem.value está en ids, lo marcamos
            if (ids.includes(checkElem.value)) {
              checkElem.checked = false;
            }
          }
        }
      }
      // Sincronizamos ac.value quitando los ids visibles
      const removeIds = self.autocomplete.items.map(el => el[idProp]);
      self.autocomplete.value = (self.autocomplete.value || []).filter(el => {
        const elId = (el && typeof el === 'object') ? el[idProp] : el;
        return !removeIds.includes(elId);
      });
      self.setValue(self.autocomplete.value);
    },
    renderSearchbar: function () {
      const self = this;
      return `
      <form class="searchbar">
        <div class="searchbar-inner">
          <div class="searchbar-input-wrap">
            <input type="search" placeholder="${self.$t('searchBarBuscar')}" class="">
            <i class="searchbar-icon"></i>
            <span class="input-clear-button"></span>
          </div>
        </div>
      </form>
      <div class="selectAllSearchBar">
        <a data-v-459f1c3b="" href="#" class="link icon-only select-all-btn has-tooltip" small="">
          <i class="icon f7-icons">checkmark_square</i>
        </a>
        <a data-v-459f1c3b="" href="#" class="link icon-only deselect-all-btn has-tooltip" small="">
          <i class="icon f7-icons">multiply_square</i>
        </a>
      </div>
      `;
    },
    updateIfEmpty: function(e) {
      if (!e.target.value && e.inputType == "deleteContentBackward") {
        this.setValue({});
        this.form.$emit("change", this.name, {});
      }
    },
    getRemoteData: function(filterInput) {
      const self = this;
      var filters = filterInput || self.filter;
      var params = Object.assign({}, filters);
      var shownFields = new Set(self.shownFields);
      shownFields.add('id');
      if(self.labelProp) shownFields.add(self.labelProp);
      if(self.prefixProp) shownFields.add(self.prefixProp);
      if(self.idProp) shownFields.add(self.idProp);
      if(self.searchProp) shownFields.add(self.searchProp);
      return {params: { filter: params }, shownFields: shownFields};
    },
    reload() {
      var self = this;
      if (self.configCombo) {
        // La carga del configcombo se hace en created() — ya está en marcha o
        // resuelta. No relanzamos aquí para evitar duplicar la consulta.
        return;
      }
      if (self.dbAdapterData) {
        const {params, shownFields} = self.getRemoteData();
        self.dbAdapterData
          .getCombo(params, [...shownFields])
          .then(function(res) {
            self.items = res.list;
            self.$emit("loaded", res.list);
          })
          .catch(function(e) {
            console.log(e);
          });
      } else {
        self.items = self.dbItems;
        self.$emit("loaded", self.dbItems);
      }
    },
    getValue: function() {
      var self = this;
      var namespaces = self.name.split(".");
      var context = self.form.formData;
      for (var i = 0; i < namespaces.length; i++) {
        if (typeof context == "undefined") {
          let n = namespaces[i];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            context = [];
          } else {
            context = {};
          }
        }
        if (typeof context == "undefined" || context == null) context = {};
        context = context[namespaces[i]];
      }
      if (typeof context == "undefined" || context == null) context = [];
      var selected = self.items.filter(function(i){
        return self.multiple ? (context.filter(c=> self.nameId ? c[self.nameId] == i[self.idProp] : c == i[self.idProp]).length > 0) : (self.nameId ? context[self.nameId] == i[self.idProp] : context == i[self.idProp]);
      });
      /*if (selected && selected.length > 0) {
        return selected[0][self.labelProp];
      }*/
      var joinStr = ", ";
      if (self.lineBreak) {
        joinStr = ",\n";
      }
      if (selected && selected.length > 0) {
        if (self.autocomplete) self.autocomplete.value = selected;
        return selected.map(el => {
          const labelValue = el[self.labelProp];
          const translatedLabel = self.isTranslationKey(labelValue) ? self.$t(labelValue) : labelValue;
          return self.prefixProp && el[self.prefixProp] ? el[self.prefixProp] + ' - ' + translatedLabel : translatedLabel;
        }).join(joinStr);
      }

      if (self.autocomplete) self.autocomplete.value = context;
      return self.multiple ? context.map(el => {
        const labelValue = el[self.labelProp];
        const translatedLabel = self.isTranslationKey(labelValue) ? self.$t(labelValue) : labelValue;
        return self.prefixProp && el[self.prefixProp] ? el[self.prefixProp] + ' - ' + translatedLabel : translatedLabel;
      }).join(joinStr): context;

    },
    showHistory: function(event) {
      const self = this;

      if(self.multiple) {
        self.history = [];
        // Si el campo es tipo array, el nombre de la propiedad será del estilo <nombreCampo>.<indice numérico>.<idCampo> y nos fijaremos en el idCampo == self.labelProp, montando como valor la concatenación de todos los prefixProp y labelProp separados por ' - '
        if(self.hasHistory) {
          // Recuperamos todas las keys de los labelprop
          Object.keys(self.form.history).filter(k=> k.startsWith(self.name) && k.endsWith(self.labelProp)).forEach(k=> {
            // para sacar los valores de los elementos del historico, le quitaremos a 'k' el <idCampo>
            let prefijo = k.split('.').slice(0,-1).join('.');
            let k1 = self.form.history[prefijo + '.' + self.prefixProp];
            let k2 = self.form.history[prefijo + '.' + self.labelProp];
            // iteramos por todos los elementos del array y los concatenamos
            for(let i=0; i<k1.length; i++) {
              // ahora sacamos los valores del campo prefixProp y labelProp
              let valor = [k1[i].valor,k2[i].valor].join(' - ');
              if(k1[i].valorAnterior && !k1[i].valor) {
                valor = '<span style="text-decoration: line-through;color:grey;">'+[k1[i].valorAnterior,k2[i].valorAnterior].join(' - ')+'</span>';
              }
              // ahora le asignamos el valor al campo de la historia:
              // si ya tenemos un valor con el mismo date y username, concatenamos los valores
              let idx = self.history.findIndex(h=> h.date == k1[i].date && h.username == k1[i].username);
              if(idx > -1) {
                self.history[idx].valor = self.history[idx].valor + ' | ' + valor;
              } else {
                self.history.push({id: k1[i].id, valor: valor, date: k1[i].date, username: k1[i].username});
              }
            }
          });
          // ordenamos la historia por fecha descendente
          self.history.sort((a,b) => {
            if (a.date < b.date) return 1;
            if (a.date > b.date) return -1;
            return 0;
          });
        }
      } else {
        // Clonamos shallow cada item para que el formateo posterior no mute el histórico original.
        self.history = (self.form.history[self.name] || []).map(itm => ({...itm}));
      }






      // vamos a formatear los campos de fecha
      for (var i = 0; i < self.history.length; i++) {
        if(self.history[i].valor === undefined) {
          self.history[i].valor = '';
        }
        if(self.history[i].valorAnterior === undefined) {
          self.history[i].valorAnterior = '';
        }

        self.history[i].valor = DateUtils.isDate(self.history[i].valor)?self.history[i].valor:DateUtils.dateFormat(self.history[i].valor, 'HH:mm');
        self.history[i].valorAnterior = DateUtils.isDate(self.history[i].valorAnterior)?self.history[i].valorAnterior:DateUtils.dateFormat(self.history[i].valorAnterior, 'HH:mm');

        self.history[i].date = DateUtils.dateFormat(self.history[i].date, 'DD/MM/YYYY HH:mm');
        self.history[i].username = self.history[i].username || '-';
      }
      if(event.target) self.$refs.popoverHistory.open(event.target);
    },
    hayCambiosOnline: function () {
      const self = this;
      if (typeof self.name === 'string' && self.name.indexOf('sesionesManuales.') === 0) return false;
      let colorear = false;
      let roles = self.form.user ? self.form.user.roles : null;
      if (roles && roles.length) {
        for (var i = 0; i < roles.length; i++) {
          if (roles[i] == 'ADMINISTRACION' || roles[i] == 'ADMIN' || roles[i] == 'DTYCAL') {
            colorear = true;
            break;
          }
        }
      }
      if (!colorear) return false;
      let history = self.form.history ? self.form.history[self.name] : null;
      history = history ? [...history] : [];
      history = history.sort((a, b) => new Date(b.date) - new Date(a.date));
      if (!history.length) return false;
      const sesionesManuales = self.form.formData ? self.form.formData.sesionesManuales : null;
      return !Utils.fechaEnSesionesManuales(history[0].date, sesionesManuales);
    },
    noCoincideHistorico: function () {
      const self = this;
      // miramos si el usuario tiene rol ADMINISTRACION, ADMIN o DTYCAL 
      let nocoincide = false;
      let roles = self.form.user ? self.form.user.roles : null;
      if (roles && roles.length) {
        for (var i = 0; i < roles.length; i++) {
          if (roles[i] == 'ADMINISTRACION' || roles[i] == 'ADMIN' || roles[i] == 'DTYCAL') {
            nocoincide = true;
            break;
          }
        }
      }
      let history = self.form.history ? self.form.history[self.name] : null;
      // ahora ordenamos el historico por fecha y nos quedamos con el elemento mas reciente
      history = history?[...history] : [];
      history = history.sort((a, b) => new Date(b.date) - new Date(a.date));
      
      // miraremos si el valor del historico más reciente, coincide con el del componente y si no coincide, devolveremos true
      return nocoincide && history && history.length && self.getStrValueHistory(history[0].valor) != self.getValue();
    },
    getStrValueHistory(valor) {
      const self = this;
      let val = valor;
      if (self.items && val) {
        let itm = self.items.filter(i => i[self.idProp] == val)[0];
        if (itm) {
          const labelValue = itm[self.labelProp];
          val = self.isTranslationKey(labelValue) ? self.$t(labelValue) : labelValue;
        }
      }
      return val;
    },
    getDateHistory(valor) {
      const self = this;
      let val = valor;
      if (val) {
        // si es un string con formato DD/MM/YYYY HH:mm lo convertimos a un objeto Date
        if (typeof val == "string" && (/^\d{2}\/\d{2}\/\d{4}[\s]+\d{2}:\d{2}(:\d{2})?$/i.test(val) )) {
          var dateParts = val.split(" ");
          var datePart = dateParts[0].split("/");
          var timePart = dateParts[1].split(":");
          // month is 0-based, that's why we need dataParts[1] - 1
          while (datePart.length < 3) {
            datePart.unshift(1);
          }
          val = new Date(datePart[2], datePart[1] - 1, + datePart[0], timePart[0], timePart[1]);
        }
        // si es una fecha en formato YYYY-MM-DD o YYYY-MM-DDTHH:mm la convertimos a un objeto Date
        else if (typeof val == "string" && (/^\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}:\d{2}$/i.test(val) || /^\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}$/i.test(val))) {
          val = new Date(val);
        }
        val = DateUtils.dateFormat(val, 'YYYY-MM-DDTHH:mm');
      }
      return val;
    },
    getValueHistory(valor) {
      const self = this;
      var context = valor;
      // si valor es un html '<span style="text-decoration: line-through;color:grey;">'+[k1[i].valorAnterior,k2[i].valorAnterior].join(' - ')+'</span>' lo dejamos en blanco
      if (context && context.indexOf('<span') > -1) {
        context = '';
      }
      
      return context;
    },
    setValueHistory: function(val, a, desdeChange = false, extraDataEmit = false, itm) {
      const self = this;
      
      itm.valor = val;
    },
    updateHistory: function(itm) {
      const self = this;
      let historyBulk = self.form.historyBulk.find(h => h.id == itm.id);
      if(historyBulk) {
        historyBulk.date = new Date(self.getDateHistory(itm.date));
        historyBulk.username = itm.username;
      }
      let namespaces = self.name.split(".");
      let context = historyBulk?.nuevo;
      for (var i = 0; i < namespaces.length; i++) {
        if (i == namespaces.length - 1) {
          self.$set(context, namespaces[i], self.toObject(itm.valor));
        } else if (context[namespaces[i]] == null) {
          self.$set(context, namespaces[i], {});
        } else if (typeof context[namespaces[i]] == "undefined") {
          let n = namespaces[i + 1];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            self.$set(context, namespaces[i], []);
          } else {
            self.$set(context, namespaces[i], {});
          }
        }
        context = context[namespaces[i]];
      }
      context = itm.valor;
      // console.log("historyBulk", context);
      // ahora guardaremos el historico con su nuevo valor
      self.form.dbAdapter.saveHistory({ itemId: historyBulk.id, data: historyBulk })
        .then(function(res) {
          window.location.reload();
          self.$f7.dialog.alert("El historico se ha actualizado correctamente.");
        })
        .catch(function(error) {
          if(error.status && error.status == 404) {
            console.log("error 404 URL: " + error.url);
          } else {
            app.dialog.alert(error.message);
          }
        });
      self.$refs.popoverHistory.close();
    },
    toObject: function(val) {
      const self = this;
      let obj = {};
      if (val && typeof val == 'string') {
        // sacamos los valores de los campos prefixProp y labelProp del string del valor (ej: '<prefixProp> - <labelProp>')
        let valParts = val.split(' - ');
        if (valParts.length > 1) {
          obj[self.prefixProp] = valParts[0];
          obj[self.labelProp] = valParts[1];
        } else {
          obj[self.labelProp] = val;
        }
      }
      return obj;
    },
    deleteFieldFromHistory: function(itm) {
      const self = this;
      self.$f7.dialog.confirm(
              "La línea de historico se eliminará y no podrá ser recuperada. ¿Está seguro?",
              "Advertencia",
              () => {
                // el delete va a ser un update en el que hemos eliminado el campo del valor actual
                let historyBulk = self.form.historyBulk.find(h => h.id == itm.id);
                let namespaces = self.name.split(".");
                let context = historyBulk?.nuevo;
                let contextParent = historyBulk?.nuevo;
                for (var i = 0; i < namespaces.length; i++) {
                  if (i == namespaces.length - 1) {
                    self.$set(context, namespaces[i], itm.valor);
                  } else if (context[namespaces[i]] == null) {
                    self.$set(context, namespaces[i], {});
                  } else if (typeof context[namespaces[i]] == "undefined") {
                    let n = namespaces[i + 1];
                    if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
                      //Número entero positivo
                      self.$set(context, namespaces[i], []);
                    } else {
                      self.$set(context, namespaces[i], {});
                    }
                  }
                  contextParent = context;
                  context = context[namespaces[i]];
                }
                // eliminamos el objeto context del contextParent
                if (contextParent) {
                  delete contextParent[namespaces[namespaces.length - 1]];
                  itm = undefined;
                }
                // ahora guardaremos el historico con su nuevo valor
                self.form.dbAdapter.saveHistory({ itemId: historyBulk.id, data: historyBulk })
                  .catch(function(error) {
                    if(error.status && error.status == 404) {
                      console.log("error 404 URL: " + error.url);
                    } else {
                      app.dialog.alert(error.message);
                    }
                  });
                self.$refs.popoverHistory.close();
              },
              () => {
                // Cancelar
              }
            );
      
    },
    setValue: function(val) {
      if (typeof val == 'undefined' || val == null) {
        val = [];
      }
      var self = this;
      var namespaces = self.name.split(".");
      var context = self.form.formData;
      for (var i = 0; i < namespaces.length; i++) {
        if (i == namespaces.length - 1) {
          self.$set(context, namespaces[i], Array.isArray(val) ? val.slice() : val);
          if (self.nameId || self.idProp) {
            var namespace = namespaces[i];
            var value = val;
            if (self.nameId) {
              namespace = self.nameId;
            }
            if (self.idProp) {
              value = val.map(function (el) {
                if (el && typeof el === 'object') {
                  return el[self.idProp];
                }
                return el;
              });
            }
            self.$set(context, namespace, self.multiple ? value: value[0]);
          }
          self.$emit("change", val);
          self.form.$emit("change", namespace, val);
        } else if (typeof context[namespaces[i]] == "undefined") {
          let n = namespaces[i + 1];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            self.$set(context, namespaces[i], []);
          } else {
            self.$set(context, namespaces[i], {});
          }
        }
        context = context[namespaces[i]];
      }
    }
  },
  created: function() {
    var self = this;
    // Si el componente carga de un configcombo, lanzamos la consulta lo antes
    // posible (en created, no en mounted) para minimizar la race con la apertura
    // del popup F7 — el usuario suele tardar más en hacer click que la consulta
    // en resolverse.
    if (self.configCombo) {
      self.configComboPromise = ConfigCombo.getList({ filter: { codigo: self.configCombo } })
        .then(function (res) {
          var c = res && res.list && res.list[0];
          var valores = (c && c.valores) || [];
          var mapped = valores.map(function (v) {
            var labelHumano = v.label || v.nombre || v.nombre_valor || v.valor;
            return Object.assign({}, v, v.metadatos || {}, { label: labelHumano, nombre: labelHumano });
          });
          self.items = mapped;
          self.$emit("loaded", mapped);
        })
        .catch(function (e) { console.log(e); });
    }
  },
  mounted() {
    var $ = this.$$;
    var $el = $(this.$el);
    var self = this;
    if (self.configCombo) {
      // Sin dbAdapter: los items vienen del configcombo (cargado en reload()).
      self.dbAdapterData = null;
    } else if (self.model) {
      self.DatabaseModel.model = self.model;
      self.dbAdapterData = self.DatabaseModel;
    } else {
      self.dbAdapterData = self.dbAdapter;
    }
    self.autocomplete = self.$f7.autocomplete.create({
      ...{
        openIn: "popup",
        popupCloseLinkText_: self.$t('cerrar'),
        popupCloseLinkText: '',
        multiple: self.multiple,
        routableModals: false,
        openerEl: $el,
        inputEl: $el.find("input"),
        preloader: true,
        highlightMatches: true,
        typeahead: true,
        requestSourceOnOpen: true,
        valueProperty: self.valueProperty || self.idProp || 'id',
        textProperty: 'txtValue',
        source: self.source(self),
        closeOnSelect: !self.multiple,
        autoFocus: true,
        pageTitle: self.label || '',
        searchbarPlaceholder: self.$t('searchBarBuscar'),
        notFoundText: self.$t('searchBarSinResultados'),
        renderSearchbar: self.multiple ? self.renderSearchbar : false,
        on: {
          change: self.onchange(self),
          opened: self.onopened(self)
        }
      },
      ...self.autocompleteProps
    });
    self.reload();
  }
};
</script>
<style scoped>
</style>
<style>
.readonly input,
.readonly select {
  pointer-events: none;
}
.autocomplete-dropdown-inner {
  max-height: 170px;
}
.autocomplete-page .selectAllSearchBar input  {
  /* width: 25%; */
}
.autocomplete-page .selectAllSearchBar {
  display: flex;
}

/* r-autocomplete-m2m chipsView mode */
.r-m2m-chips-field {
  display: flex;
  flex-direction: column;
  padding: 6px 12px 8px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  cursor: pointer;
  background: transparent;
}
.r-m2m-chips-field.readonly {
  cursor: default;
  pointer-events: none;
}
.r-m2m-chips-field.has-error {
  border-bottom-color: #d32f2f;
}
.r-m2m-chips-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.2;
  margin-bottom: 4px;
}
.r-m2m-chips-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-height: 24px;
}
.r-m2m-chip {
  display: inline-flex !important;
  align-items: center;
  gap: 10px;
  background: #e8eef5;
  color: #22355b;
  border-radius: 12px;
  padding: 2px 6px 2px 10px;
  font-size: 12px;
  line-height: 18px;
  width: fit-content;
  max-width: 100%;
  flex: 0 0 auto;
}
.r-m2m-chip-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 500px;
  color: #22355b;
}
.r-m2m-chip-close {
    background: transparent;
    border: 0;
    color: #ffffff;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    /* padding: 0 4px; */
    font-weight: bold;
    flex-shrink: 0;
    width: 12px;
}
.r-m2m-chip-close:hover {
  color: #d32f2f;
}
.r-m2m-chips-placeholder {
  color: rgba(0, 0, 0, 0.45);
  font-size: 13px;
  font-style: italic;
}
.r-m2m-chips-hidden-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
  border: 0;
  padding: 0;
  margin: 0;
}
.r-m2m-chips-error {
  color: #d32f2f;
  font-size: 11px;
  margin-top: 4px;
}
</style>